export const createEl = (slc) => document.createElement(slc);

export const container = createEl('div');

export const backdrop = createEl('div');

export const highlight = createEl('div');

export const root = document.documentElement;

export const styler = (_el, _style) => {
	Object.keys(_style).forEach((name) => (_el.style[name] = _style[name]));
};

export const appendToContainer = (_el) => {
	containerHas(_el) || container.appendChild(_el);
};

export const containerHas = (_el) => {
	return container.contains(_el);
};

export const containerRemoveChild = () => {
	const fade = { opacity: 0 };
	styler(backdrop, fade);
	styler(highlight, fade);
	setTimeout(() => {
		container.innerHTML = '';
		removeStyle([backdrop, highlight]);
	}, parseInt(backdrop.style.transition.match(/(\d+)/)));
};

const removeStyle = (elements) => {
	for (const iterator of elements) {
		iterator.removeAttribute('style');
	}
};

export const is = {
	fnc: (a) => typeof a === 'function',
	str: (a) => typeof a === 'string',
	obj: (a) => a.$$typeof && a.$$typeof.toString().includes('react.forward_ref'),
	dev: process.env.NODE_ENV === 'developement'
};

export const isReferable = (elementType) =>is.str(elementType.type) || is.obj(elementType.type);

export const DoneTypingEvent = (callback, ms = 700, withKeyboardCB) => {
	let timeoutReference;

	const typingEventHandlerForChildren = (event) => {
		const { type, keyCode, target, which } = event;
		const isInputBlurOrPressEnter =
			type === 'blur' ||
			(target.nodeName !== 'TEXTAREA' && (keyCode === 13 || which === 13));
		const typeIsKeyUpUnlessItIsBackspace = type === 'keyup' && keyCode !== 8;
		
		is.fnc(withKeyboardCB) &&
			type !== 'blur' &&
			withKeyboardCB(event);

		if (isInputBlurOrPressEnter) {
			if (timeoutReference) {
				clearTimeout(timeoutReference);
				timeoutReference = undefined;
			}
			return callback(event);
		}

		if (typeIsKeyUpUnlessItIsBackspace) return;

		if (timeoutReference) clearTimeout(timeoutReference);

		timeoutReference = setTimeout(() => {
			callback(event);
			timeoutReference = undefined;
		}, ms);
	};

	return {
		onBlur: typingEventHandlerForChildren,
		onKeyUp: typingEventHandlerForChildren,
		onKeyPress: typingEventHandlerForChildren,
	};
};

export const leavingTransition = (
	target,
	reference,
	gesture,
	matchedRequirement,
	isRemovableStyle
) => {
	const isLeavingIndex = target && reference && !matchedRequirement;
	let unset;
	const tar = target;
	if (isLeavingIndex) {
		styler(reference, {
			opacity: 0,
		});
		gesture &&
			styler(gesture, {
				opacity: 0,
			});
		unset = setTimeout(
			() =>
				styler(target, {
					zIndex: null,
				}),
			50
		);
	}

	return {
		unmount() {
			clearTimeout(unset);
			if (isRemovableStyle) {
				styler(tar, {
					zIndex: null,
					position: null, 
					display: null,
					boxShadow: null
				});
			}
		},
	};
};

export const autoScrollToTarget = (
	{ targetTop, targetLeft },
	autoScrollDelay
) => {
	const { innerHeight, innerWidth } = window;
	const { scrollTop, scrollLeft } = root;
	const insideViewHeight =
		scrollTop + innerHeight * 0.2 < targetTop &&
		scrollTop + innerHeight * 0.8 > targetTop;
	const insideViewWidth =
		scrollLeft + innerWidth * 0.2 < targetLeft &&
		scrollLeft + innerWidth * 0.8 > targetLeft;
	/*after effect when step is out in view port*/
	let delay;
	if (!insideViewHeight || !insideViewWidth)
		delay = setTimeout(() => {
			if (!insideViewHeight) root.scrollTop = targetTop - innerHeight * 0.5;
			if (!insideViewWidth) root.scrollLeft = targetLeft - innerWidth * 0.5;
		}, autoScrollDelay);

	return {
		unmount() {
			clearTimeout(delay);
		},
	};
};

export const settingBackground = (
	target,
	reference,
	gesture,
	background,
	duration = 200,
	isSingleton,
	isOriginal
) => {
	const {
		backdropStyle = {},
		highlightStyle = {},
		gestureStyle = {},
	} = background;
	const children = isOriginal ? target.children[0] : target;
	const { borderRadius } = window.getComputedStyle(children);
	const { top, left, height, width } = children.getBoundingClientRect();
	const targetTop = top + root.scrollTop;
	const targetLeft = left + root.scrollLeft;
	const transition = `${duration}ms ease-in-out`;
	const commonStyle = { opacity: 1, transition: `all ${transition}` };
	const opacityStyle = { opacity: 1 };
	const hasHighlight = containerHas(highlight);
	// const hasBackground = containerHas(background);
	appendToContainer(backdrop);
	appendToContainer(highlight);
	const highlight_pos = {
		top: `${targetTop}px`,
		left: `${targetLeft}px`,
		height: `${height}px`,
		width: `${width}px`,
		borderRadius,
	};
	hasHighlight || styler(highlight, highlight_pos);
	gesture &&
		styler(gesture, {
			position: 'absolute',
			top: `${targetTop + height / 2}px`,
			left: `${targetLeft + width / 2}px`,
		});
	reference &&
		isSingleton &&
		styler(reference, { transition: `all ${transition}` });
	styler(highlight, {
		willChange: 'top, left, width, height, border-radius, background-color',
	});
	setTimeout(() => {
		// hasBackground ||
		styler(backdrop, {
			opacity: 1,
			transition: `opacity ${transition}`,
			...backdropStyle,
		});
		// hasHighlight ||
		styler(highlight, {
			...commonStyle,
			...highlightStyle,
			...highlight_pos,
		});
		// hasHighlight && styler(highlight, highlight_pos);
		reference && styler(reference, opacityStyle);

		gesture && styler(gesture, { ...opacityStyle, ...gestureStyle });
	}, 0);

	return {
		targetLeft,
		targetTop,
	};
};

const convertEventPropsIntoEventListeners = (
	target,
	eventProps,
	type = 'add'
) =>
	Object.keys(eventProps).forEach((key) => {
		target[`${type}EventListener`](
			key.substr(2).toLowerCase(),
			eventProps[key],
			false
		);
	});
const targetEventListeners = (target, eventProps) => {
	convertEventPropsIntoEventListeners(target, eventProps);
	return {
		unmount() {
			convertEventPropsIntoEventListeners(target, eventProps, 'remove');
		},
	};
};

const targetHighlightAfterDuration = (target, duration) => {
	const cleanUp = setTimeout(
		() => {
			const { position } = window.getComputedStyle(target)
			styler(target, {
				zIndex: '1000000',
				position: position === 'static' ? 'relative' : position,
				boxShadow: 'none'
			})
		},
		duration
	);

	return {
		unmount() {
			clearTimeout(cleanUp);
		},
	};
};

export const backgroundPlacements = (
	target,
	reference,
	gesture,
	matchedRequirement,
	autoScrollDelay,
	background,
	duration,
	isSingleton,
	isReferableChildren,
	isOriginal,
	original,
	targetEventProps
) => {
	const leavingTrans = leavingTransition(
		target,
		reference,
		gesture,
		matchedRequirement,
		isSingleton || isReferableChildren
	);

	if (!matchedRequirement) return { isFailed: true };
	
	if(isOriginal) { 
		const { display } = window.getComputedStyle(original.children[0]);

		styler(original, {
			display,
		});
	}

	const resize = () =>
		settingBackground(
			target,
			reference,
			gesture,
			background,
			duration,
			isSingleton,
			isOriginal
		);

	const autoscroll = autoScrollToTarget(resize(), autoScrollDelay);

	const targetEvents = targetEventListeners(target, targetEventProps);

	const targetHighlight = targetHighlightAfterDuration(target, duration);

	windowEventListener('add', ['resize', 'scroll'], resize);
	return {
		unmount() {
			windowEventListener('remove', ['resize', 'scroll'], resize);
			autoscroll.unmount();
			targetEvents.unmount();
			leavingTrans.unmount();
			targetHighlight.unmount();
		},
	};
};

const windowEventListener = (type, events, cb) =>
	events.forEach((event) => {
		window[`${type}EventListener`](event, cb, false);
	});

highlight.addEventListener('transitionend', () =>
	styler(highlight, { willChange: null })
);

backdrop.id = 'chaperone-backdrop';

highlight.id = 'chaperone-highlight';

// container.id = 'chaperone';

document.body.appendChild(container);
